import Vue from 'vue'
import App from './App.vue'
import router from './router'
import device from 'current-device'

Vue.config.productionTip = false;

import BabylonStory from "./BabylonStory/BabylonStory";
const config = require('./config');
Vue.use(BabylonStory, {
    config, router
});

new Vue({
    router,
    device,
    render: h => h(App),
}).$mount('#app');
